import { render, staticRenderFns } from "./SliderContent.vue?vue&type=template&id=5e889856&scoped=true"
import script from "./SliderContent.vue?vue&type=script&lang=js"
export * from "./SliderContent.vue?vue&type=script&lang=js"
import style0 from "./SliderContent.vue?vue&type=style&index=0&id=5e889856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e889856",
  null
  
)

export default component.exports